var _rect, _rect2, _rect3, _rect4, _rect5, _g, _rect6, _g2, _rect7, _g3, _g4, _g5, _g6, _rect8, _rect9, _rect10, _mask, _rect11, _mask2, _rect12, _mask3, _rect13, _circle, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _circle2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpRipening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.544922,
    y: 0.848877,
    width: 68.6176,
    height: 68.6176,
    rx: 9.80251,
    fill: "#FFF0EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.0837,
    y: 26.4289,
    width: 9.36957,
    height: 3.45013,
    rx: 1.72507,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.167306
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8239,
    y: 33.0058,
    width: 9.36957,
    height: 3.45013,
    rx: 1.72507,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.167306
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9196,
    y: 39.5837,
    width: 9.36957,
    height: 3.45013,
    rx: 1.72507,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.167306
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1081,
    y: 26.4289,
    width: 9.36957,
    height: 3.45013,
    rx: 1.72507,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.167306
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_863_24737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2576 27.3722C26.8495 27.1749 26.7783 27.6736 26.6686 27.9477C26.6275 28.1532 26.6686 28.441 26.7509 28.6876C26.5207 29.148 26.2576 28.9342 26.1754 28.7287C25.8465 28.3999 26.0109 27.5777 26.2576 27.3722Z",
    fill: "white"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0114,
    y: 33.0058,
    width: 9.36957,
    height: 3.45013,
    rx: 1.72507,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.167306
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_863_24737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1609 33.9501C27.7528 33.7527 27.6816 34.2515 27.572 34.5256C27.5309 34.7311 27.572 35.0188 27.6542 35.2655C27.424 35.7259 27.1609 35.5121 27.0787 35.3066C26.7498 34.9777 26.9143 34.1556 27.1609 33.9501Z",
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1081,
    y: 39.5837,
    width: 9.36957,
    height: 3.45013,
    rx: 1.72507,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.167306
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_863_24737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2576 40.5275C26.8495 40.3301 26.7783 40.8289 26.6686 41.103C26.6275 41.3085 26.6686 41.5962 26.7509 41.8429C26.5207 42.3033 26.2576 42.0895 26.1754 41.884C25.8465 41.5551 26.0109 40.733 26.2576 40.5275Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_863_24737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2341 27.3732C40.8261 27.1758 40.7548 27.6746 40.6452 27.9487C40.6041 28.1542 40.6452 28.4419 40.7274 28.6886C40.4972 29.149 40.2341 28.9352 40.1519 28.7297C39.8231 28.4008 39.9875 27.5787 40.2341 27.3732Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_863_24737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9734 33.9513C41.5653 33.754 41.4941 34.2527 41.3845 34.5268C41.3434 34.7323 41.3845 35.0201 41.4667 35.2667C41.2365 35.7271 40.9734 35.5133 40.8912 35.3078C40.5623 34.979 40.7268 34.1568 40.9734 33.9513Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_863_24737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4177 40.7784C41.0097 40.5811 40.9384 41.0799 40.8288 41.3539C40.7877 41.5595 40.8288 41.8472 40.911 42.0939C40.6808 42.5543 40.4177 42.3405 40.3355 42.135C40.0067 41.8061 40.1711 40.984 40.4177 40.7784Z",
    fill: "white"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3672,
    y: 30.2097,
    width: 25.9798,
    height: 2.05536,
    fill: "#ED5E2A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3672,
    y: 36.6226,
    width: 25.9798,
    height: 2.05536,
    fill: "#ED5E2A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3672,
    y: 43.2812,
    width: 25.9798,
    height: 2.05536,
    fill: "#ED5E2A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-1_863_24737",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.3936,
    y: 23.8796,
    width: 1.97315,
    height: 24.5821,
    rx: 0.836532
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3936,
    y: 23.8796,
    width: 1.97315,
    height: 24.5821,
    rx: 0.836532,
    fill: "white",
    stroke: "#ED5E2A",
    strokeWidth: 1.97315,
    mask: "url(#path-17-inside-1_863_24737)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-2_863_24737",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.3701,
    y: 23.8796,
    width: 1.97315,
    height: 24.5821,
    rx: 0.836532
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3701,
    y: 23.8796,
    width: 1.97315,
    height: 24.5821,
    rx: 0.836532,
    fill: "white",
    stroke: "#ED5E2A",
    strokeWidth: 1.97315,
    mask: "url(#path-18-inside-2_863_24737)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-3_863_24737",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.3457,
    y: 23.8796,
    width: 1.97315,
    height: 24.5821,
    rx: 0.836532
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3457,
    y: 23.8796,
    width: 1.97315,
    height: 24.5821,
    rx: 0.836532,
    fill: "white",
    stroke: "#ED5E2A",
    strokeWidth: 1.97315,
    mask: "url(#path-19-inside-3_863_24737)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.7284,
    cy: 20.2206,
    r: 5.22062,
    fill: "#ED5E2A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3682,
    y: 17.6077,
    width: 0.73993,
    height: 3.83036,
    rx: 0.369965,
    transform: "rotate(-47.8638 40.3682 17.6077)",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5098,
    y: 18.0415,
    width: 0.73993,
    height: 3.60292,
    rx: 0.369965,
    transform: "rotate(58.4149 46.5098 18.0415)",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6533,
    y: 19.8572,
    width: 0.73993,
    height: 1.75783,
    rx: 0.369965,
    transform: "rotate(90.2232 48.6533 19.8572)",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 40.6797,
    y: 19.8577,
    width: 0.73993,
    height: 1.75783,
    rx: 0.369965,
    transform: "rotate(90.2232 40.6797 19.8577)",
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 44.0977,
    y: 25.0007,
    width: 0.73993,
    height: 1.75783,
    rx: 0.369965,
    transform: "rotate(-178.263 44.0977 25.0007)",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 44.0977,
    y: 17.1907,
    width: 0.73993,
    height: 1.75783,
    rx: 0.369965,
    transform: "rotate(-178.263 44.0977 17.1907)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.7692,
    cy: 20.1794,
    r: 0.73993,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4372 33.09L15.435 33.0901C14.2599 33.085 13.4248 33.0921 12.6194 33.8462C12.2801 34.2618 12.1499 34.4292 12.083 34.7185C12.0093 35.0367 12.0138 35.4973 12.0276 36.5082C12.0276 36.5083 12.0276 36.5084 12.0276 36.5084L15.4372 33.09ZM15.4372 33.09L15.9233 33.0876C15.9234 33.0876 15.9235 33.0876 15.9236 33.0876C16.2612 33.0866 16.5989 33.087 16.9366 33.0887L16.9369 33.0887C17.4545 33.0906 17.9714 33.086 18.4872 33.081C18.8164 33.0809 19.1455 33.0811 19.4747 33.0818L19.4778 33.0818L19.94 33.0765C20.4892 33.0829 20.9067 33.1475 21.2777 33.2974C21.6423 33.4447 21.9781 33.6809 22.3556 34.0552C22.8044 34.7948 22.851 35.6005 22.9036 36.5089C22.9089 36.6014 22.9143 36.695 22.9202 36.7896L22.9439 37.1682L23.2688 36.9725L23.5967 36.7751M15.4372 33.09L23.5967 36.7751M23.5967 36.7751L23.5978 36.7744L24.0292 36.518L24.0297 36.5177L24.4537 36.2642M23.5967 36.7751L24.4537 36.2642M24.4537 36.2642C24.7156 36.1228 24.8772 36.0423 25.0374 36.0059C25.1849 35.9723 25.3464 35.9736 25.6019 36.0345C25.9033 36.1628 26.0197 36.2143 26.0906 36.265C26.1388 36.2995 26.1625 36.3299 26.2386 36.4554C26.282 36.7921 26.3006 36.9447 26.3006 37.0533C26.3006 37.1394 26.2893 37.1927 26.2536 37.3228C25.6711 37.9527 24.9983 38.3493 24.2206 38.7988L24.2201 38.7991C23.9855 38.9355 23.7534 39.0752 23.5229 39.2141C22.7986 39.6353 22.4747 39.8215 22.2167 39.8957C21.9912 39.9605 21.8186 39.9392 21.3853 39.8674C21.2357 39.7614 21.1468 39.6836 21.0825 39.5988C21.0161 39.511 20.965 39.4011 20.9156 39.2126C20.8568 38.8242 20.8355 38.4437 20.8221 38.0397L20.8221 38.0393L20.8053 37.5577L20.8053 37.5569L20.7895 37.0577L20.7895 37.0571L20.7722 36.5494C20.7722 36.5494 20.7722 36.5494 20.7722 36.5494C20.7582 36.1367 20.7447 35.724 20.7316 35.3112L20.2712 35.3178L20.2702 35.6117C20.2624 37.9713 20.2524 40.3308 20.24 42.6904C20.234 43.8317 20.2288 44.973 20.2253 46.1144C20.2223 47.1088 20.2179 48.1031 20.2118 49.0975C20.2086 49.6243 20.2061 50.1513 20.2053 50.6785C20.2045 51.1737 20.2019 51.6689 20.1978 52.1642L20.1978 52.1646C20.1961 52.4337 20.1963 52.7027 20.1966 52.9707C20.1966 52.9712 20.1966 52.9716 20.1966 52.972L20.1916 53.455L20.1916 53.4564L20.1898 53.8624C20.1386 54.2265 20.031 54.438 19.8071 54.7526C19.4707 54.9855 19.1694 55.0104 18.7144 54.959C18.4948 54.8484 18.3457 54.7657 18.2257 54.663C18.109 54.5631 18.0119 54.4368 17.9182 54.2271C17.8024 53.7574 17.7831 53.3138 17.7882 52.8104L17.7882 52.808L17.7881 52.4987C17.7881 52.4986 17.7881 52.4986 17.7881 52.4986C17.7883 52.164 17.7903 51.8294 17.7924 51.494L17.7924 51.493C17.7929 51.2596 17.7933 51.0261 17.7935 50.7926C17.7945 50.1804 17.7971 49.568 17.8001 48.9555L17.8001 48.9554C17.8026 48.378 17.8038 47.8006 17.805 47.2236L17.8053 47.0774C17.8082 45.8509 17.8127 44.6243 17.8183 43.3978L17.8193 43.1665H17.588H17.5872H17.5865H17.5857H17.5849H17.5842H17.5834H17.5826H17.5819H17.5811H17.5803H17.5796H17.5788H17.578H17.5773H17.5765H17.5757H17.5749H17.5742H17.5734H17.5726H17.5719H17.5711H17.5703H17.5696H17.5688H17.568H17.5673H17.5665H17.5657H17.565H17.5642H17.5634H17.5627H17.5619H17.5611H17.5603H17.5596H17.5588H17.558H17.5573H17.5565H17.5557H17.555H17.5542H17.5534H17.5527H17.5519H17.5511H17.5504H17.5496H17.5488H17.5481H17.5473H17.5465H17.5457H17.545H17.5442H17.5434H17.5427H17.5419H17.5411H17.5404H17.5396H17.5388H17.5381H17.5373H17.5365H17.5358H17.535H17.5342H17.5335H17.5327H17.5319H17.5311H17.5304H17.5296H17.5288H17.5281H17.5273H17.5265H17.5258H17.525H17.5242H17.5235H17.5227H17.5219H17.5212H17.5204H17.5196H17.5188H17.5181H17.5173H17.5165H17.5158H17.515H17.5142H17.5135H17.5127H17.5119H17.5112H17.5104H17.5096H17.5088H17.5081H17.5073H17.5065H17.5058H17.505H17.5042H17.5035H17.5027H17.5019H17.5012H17.5004H17.4996H17.4988H17.4981H17.4973H17.4965H17.4958H17.495H17.4942H17.4935H17.4927H17.4919H17.4912H17.4904H17.4896H17.4888H17.4881H17.4873H17.4865H17.4858H17.485H17.4842H17.4835H17.4827H17.4819H17.4811H17.4804H17.4796H17.4788H17.4781H17.4773H17.4765H17.4758H17.475H17.4742H17.4734H17.4727H17.4719H17.4711H17.4704H17.4696H17.4688H17.4681H17.4673H17.4665H17.4657H17.465H17.4642H17.4634H17.4627H17.4619H17.4611H17.4603H17.4596H17.4588H17.458H17.4573H17.4565H17.4557H17.455H17.4542H17.4534H17.4526H17.4519H17.4511H17.4503H17.4496H17.4488H17.448H17.4472H17.4465H17.4457H17.4449H17.4442H17.4434H17.4426H17.4418H17.4411H17.4403H17.4395H17.4388H17.438H17.4372H17.4364H17.4357H17.4349H17.4341H17.4334H17.4326H17.4318H17.431H17.4303H17.4295H17.4287H17.428H17.4272H17.4264H17.4256H17.4249H17.4241H17.4233H17.4225H17.4218H17.421H17.4202H17.4195H17.4187H17.4179H17.4171H17.4164H17.4156H17.4148H17.4141H17.4133H17.4125H17.4117H17.411H17.4102H17.4094H17.4086H17.4079H17.4071H17.4063H17.4055H17.4048H17.404H17.4032H17.4025H17.4017H17.4009H17.4001H17.3994H17.3986H17.3978H17.397H17.3963H17.3955H17.3947H17.3939H17.3932H17.3924H17.3916H17.3909H17.3901H17.3893H17.3885H17.3878H17.387H17.3862H17.3854H17.3847H17.3839H17.3831H17.3823H17.3816H17.3808H17.38H17.3792H17.3785H17.3777H17.3769H17.3761H17.3754H17.3746H17.3738H17.373H17.3723H17.3715H17.3707H17.3699H17.3692H17.3684H17.3676H17.3668H17.3661H17.3653H17.3645H17.3637H17.363H17.3622H17.3614H17.3606H17.3599H17.3591H17.3583H17.3575H17.3567H17.356H17.3552H17.3544H17.3536H17.3529H17.3521H17.3513H17.3505H17.3498H17.349H17.3482H17.3474H17.3467H17.3459H17.3451H17.3443H17.3435H17.3428H17.342H17.3412H17.3404H17.3397H17.3389H17.3381H17.3373H17.3365H17.3358H17.335H17.3342H17.3334H17.3327H17.3319H17.3311H17.3303H17.3295H17.3288H17.328H17.3272H17.3264H17.3257H17.3249H17.3241H17.3233H17.3225H17.3218H17.321H17.3202H17.3194H17.3186H17.3179H17.3171H17.3163H17.3155H17.3148H17.314H17.3132H17.3124H17.3116H17.3109H17.3101H17.3093H17.3085H17.3077H17.307H17.3062H17.3054H17.3046H17.3038H17.3031H17.3023H17.3015H17.3007H17.2999H17.2992H17.2984H17.2976H17.2968H17.296H17.2952H17.2945H17.2937H17.2929H17.2921H17.2913H17.2906H17.2898H17.289H17.2882H17.2874H17.2867H17.2859H17.2851H17.2843H17.2835H17.2827H17.282H17.2812H17.2804H17.2796H17.2788H17.278H17.2773H17.2765H17.2757H17.2749H17.2741H17.2734H17.2726H17.2718H17.271H17.2702H17.2694H17.2687H17.2679H17.2671H17.2663H17.2655H17.2647H17.264H17.2632H17.2624H17.2616H17.2608H17.26H17.2592H17.2585H17.2577H17.2569H17.2561H17.2553H17.2545H17.2538H17.253H17.2522H17.2514H17.2506H17.2498H17.249H17.2483H17.2475H17.2467H17.2459H17.2451H17.2443H17.2435H17.2428H17.242H17.2412H17.2404H17.2396H17.2388H17.238H17.2373H17.2365H17.2357H17.2349H17.2341H17.2333H17.2325H17.2318H17.231H17.2302H17.2294H17.2286H17.2278H17.227H17.2262H17.2255H17.2247H17.2239H17.2231H17.2223H17.2215H17.2207H17.2199H17.2192H17.2184H17.2176H17.2168H17.216H17.2152H17.2144H17.2136H17.2128H17.2121H17.2113H17.2105H17.2097H17.2089H17.2081H17.2073H17.2065H17.2057H17.2049H17.2042H17.2034H17.2026H17.2018H17.201H17.2002H17.1994H17.1986H17.1978H17.197H17.1963H17.1955H17.1947H17.1939H17.1931H17.1923H17.1915H17.1907H16.9589L16.9605 43.3982L16.9631 43.806C16.9712 45.0742 16.9771 46.3425 16.981 47.6107V47.6108C16.9831 48.2631 16.9859 48.9155 16.9904 49.568C16.9947 50.197 16.9971 50.8259 16.9981 51.455L16.9981 51.4553C16.9989 51.6958 17.0003 51.9363 17.0025 52.1768C17.0025 52.1769 17.0025 52.1769 17.0025 52.1769L17.2327 52.1749M24.4537 36.2642L17.0099 53.4854M17.2327 52.1749C17.2356 52.5113 17.236 52.8476 17.2358 53.184L17.2401 53.4844M17.2327 52.1749C17.2306 51.9348 17.2291 51.6947 17.2284 51.4546L17.2327 52.1749ZM17.2401 53.4844L17.0099 53.4831C17.0099 53.4838 17.0099 53.4846 17.0099 53.4854M17.2401 53.4844L17.0099 53.4878L17.0099 53.4854M17.2401 53.4844C17.2367 54.0749 17.1546 54.4471 16.7934 54.9181M17.0099 53.4854C17.0081 53.7704 16.9872 53.986 16.9299 54.1814C16.8757 54.3665 16.7856 54.5448 16.6313 54.7508M16.7934 54.9181L16.6584 54.7316C16.6493 54.7382 16.6403 54.7446 16.6313 54.7508M16.7934 54.9181C16.3672 55.2268 15.985 55.2449 15.4691 55.183L15.542 54.9596C15.9948 55.0103 16.2954 54.9843 16.6313 54.7508M16.7934 54.9181L16.6107 54.778C16.6177 54.7689 16.6245 54.7598 16.6313 54.7508M14.1748 40.123C14.1791 40.6132 14.1815 41.1035 14.1825 41.5938M14.1748 40.123C14.1703 39.6151 14.1675 39.1073 14.1654 38.5994C14.1615 37.6115 14.1555 36.6237 14.1475 35.6358M14.1748 40.123L13.9446 40.125C13.9446 40.125 13.9446 40.125 13.9446 40.125M14.1748 40.123L13.9446 40.125M14.1825 41.5938L14.502 50.5108C14.4993 50.0277 14.4961 49.5446 14.4929 49.0614L14.4919 48.9095C14.4853 47.8983 14.4793 46.8871 14.4736 45.8759C14.4671 44.7249 14.4598 43.5739 14.4525 42.4229C14.4374 40.0548 14.4232 37.6867 14.4097 35.3185H14.3751L14.3751 35.3166L14.1448 35.3185V35.5488H14.1454H14.1459H14.1464H14.1468L14.1475 35.6358M14.1825 41.5938C14.1833 41.7807 14.1847 41.9675 14.1868 42.1544L14.1825 41.5938ZM14.1475 35.6358L13.9173 35.6378M14.1475 35.6358L13.9173 35.6377L13.9173 35.6378M13.9173 35.6378C13.9252 36.6253 13.9313 37.6128 13.9352 38.6003L13.9352 38.6004C13.9372 39.1084 13.94 39.6166 13.9446 40.125M13.9173 35.6378L13.9566 42.1569C13.9544 41.9695 13.953 41.7821 13.9523 41.5947L13.9523 41.5943C13.9512 41.1044 13.9489 40.6147 13.9446 40.125M13.9597 42.9422L13.9597 42.9409C13.9596 42.6786 13.9595 42.4177 13.9566 42.157L13.9597 42.9422ZM13.9597 42.9422L13.9623 43.3794C13.937 43.5846 13.8991 43.7332 13.8414 43.8681C13.7868 43.9957 13.7105 44.1199 13.5962 44.2742C13.4042 44.3686 13.2732 44.4218 13.1462 44.4448C13.0213 44.4674 12.8853 44.4632 12.6834 44.4142C12.417 44.2624 12.2772 44.1725 12.1135 43.967C12.0956 43.8328 12.0851 43.7512 12.0787 43.6692C12.0696 43.553 12.0686 43.4361 12.0661 43.1674L12.0661 43.1662M13.9597 42.9422L12.0661 43.1662M12.0661 43.1662L12.062 42.8944C12.062 42.8943 12.062 42.8942 12.062 42.8941C12.0583 42.5982 12.0575 42.3021 12.0571 42.0049L12.0571 42.0038M12.0661 43.1662L12.0571 42.0038M12.0571 42.0038L12.0531 41.3818C12.0531 41.3817 12.0531 41.3817 12.053 41.3817C12.0507 40.947 12.0499 40.5122 12.0502 40.0773V40.0772M12.0571 42.0038L12.0502 40.0772M12.0502 40.0772C12.0502 39.5205 12.0448 38.9644 12.0379 38.4089M12.0502 40.0772L12.0379 38.4089M12.0379 38.4089C12.0379 38.409 12.0379 38.409 12.0379 38.4091L11.8077 38.4115C11.8145 38.9668 11.82 39.5219 11.8199 40.0772L12.0379 38.4089Z",
    fill: "#ED5E2A",
    stroke: "white",
    strokeWidth: 0.460524
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0571 27.8906C17.439 27.8087 17.8437 27.8342 18.3045 28.0018C18.9025 28.3896 19.3212 28.7652 19.4808 29.4013C19.5807 30.1925 19.5178 30.75 19.0701 31.3728C18.6799 31.8002 18.3333 32.0081 17.7722 32.0877C17.1194 32.1113 16.6623 32.0505 16.1498 31.6991C15.6441 31.1694 15.3103 30.7715 15.2987 30.1157C15.3205 29.7578 15.3598 29.4741 15.4475 29.216C15.5329 28.9648 15.6675 28.7278 15.8922 28.4691C16.2929 28.1693 16.6713 27.9733 17.0571 27.8906Z",
    fill: "#ED5E2A",
    stroke: "white",
    strokeWidth: 0.460524
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_863_24737",
    x: 25.322,
    y: 27.3271,
    width: 2.09822,
    height: 2.97322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.669226
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.334613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_24737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_24737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_863_24737",
    x: 26.2253,
    y: 33.905,
    width: 2.09822,
    height: 2.97322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.669226
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.334613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_24737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_24737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_863_24737",
    x: 25.322,
    y: 40.4824,
    width: 2.09822,
    height: 2.97322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.669226
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.334613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_24737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_24737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_863_24737",
    x: 39.2985,
    y: 27.3281,
    width: 2.09822,
    height: 2.97322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.669226
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.334613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_24737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_24737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_863_24737",
    x: 40.0378,
    y: 33.9062,
    width: 2.09822,
    height: 2.97322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.669226
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.334613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_24737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_24737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_863_24737",
    x: 39.4821,
    y: 40.7334,
    width: 2.09822,
    height: 2.97322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.669226
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.334613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_24737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_24737",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpRipening);
export default __webpack_public_path__ + "static/media/emp_ripening.aab5c6b0fc56fed1a3e3a103131c635c.svg";
export { ForwardRef as ReactComponent };